export const CategorySelect = ({ categories, value, onChange, id }) => (
  <select className="mt-1 w-full rounded-sm border border-line bg-surface px-3 py-2.5 text-sm normal-case tracking-normal" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={id}>
    <option value="">Sin categoría</option>
    {categories.filter((c) => !c.parent_id).map((g) => (
      <optgroup key={g.id} label={g.name}>
        <option value={g.id}>{g.name} (general)</option>
        {categories.filter((c) => c.parent_id === g.id).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </optgroup>
    ))}
  </select>
);
